import { render, staticRenderFns } from "./Energylabel.vue?vue&type=template&id=8ac9da5e"
import script from "./Energylabel.vue?vue&type=script&setup=true&lang=js"
export * from "./Energylabel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports